import clamp from './clamp.js'

function create({$window, $nav, offset}) {
  const height = $nav.height();
  let scrollPosition = $window.scrollTop();
  let scrollVector = 0;
  let isSticky = false;
  let topOffset = offset.parent;

  function fix(offset) {
    $nav.css({
      'position': 'fixed',
      'top': offset
    });
    isSticky = true;
    $window.trigger('navOffset:update');
    return {
      isSticky,
      scrollPosition: $window.scrollTop(),
      isHidden: false
    };
  }
  function unfix(top) {
    $nav.css({
      'position': 'absolute',
      top: `${top}px`
    });
    topOffset = top;
    isSticky = false;
    $window.trigger('navOffset:update');
  }

  function update({offset}) {
    const previousScrollPosition = scrollPosition;
    const previousScrollVector = scrollVector;

    scrollPosition = clamp({value: $window.scrollTop(), min: 0});
    scrollVector = scrollPosition - previousScrollPosition;

    const isHidden = !isSticky && scrollPosition > (topOffset + height);
    if (isHidden) {
      // User scrolls down then starts scrolling back up again
      if (previousScrollVector >= 0 && scrollVector <= 0) {
        unfix(scrollPosition - height);
      }
    // Nav is visible
    } else {
      // Page scrolls above parent offset
      if (scrollPosition <= offset.parent) {
        unfix(offset.parent);
      } else {
        // Nav moves when the page scrolls
        if (!isSticky) {
          // Nav is fully in view
          if (scrollPosition <= topOffset) {
            fix(offset.page);
          }
        // Nav is fixed and user is scrolling down
        } else if (scrollVector >= 0) {
          unfix(scrollPosition);
        }
      }
    }
    return {isSticky, scrollPosition, isHidden, topOffset};
  }
  return {update, fix};
}
export {create};
